import { infiniteQueryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, MessagesPageResponseDataSchema } from "schema"
import { z } from "zod"

export type MessagesPage = z.infer<typeof MessagesPageResponseDataSchema>
type Response = DataResponse<MessagesPage>

type PageParam = { before?: string }

export const getMessagesQueryKey = (conversationId: string) => ["messages", { conversationId }]

type Options = {
  limit?: number
  enabled?: boolean
}

export const messagesQuery = (conversationId: string, options: Options = {}) => {
  const limit = options.limit ?? 50

  return infiniteQueryOptions({
    queryKey: getMessagesQueryKey(conversationId),
    placeholderData: undefined,
    initialPageParam: {} as PageParam,
    queryFn: async ({ pageParam }) => {
      const response = await axios.get<Response>("/messages", {
        params: {
          conversationId,
          limit,
          before: pageParam.before,
        },
      })
      return response.data.data
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage.pageInfo.hasMore || !lastPage.pageInfo.oldestId) return undefined
      return { before: lastPage.pageInfo.oldestId }
    },
    getPreviousPageParam: () => undefined,
    enabled: options.enabled,
  })
}
